// import logo from "./asset-source/logo.gif";
import "./typo.css";
import "./about.css";
import "./newfooter.css";

import plane from "./asset-source/plane.png";
import cloud from "./asset-source/cloud.png";
import sky from "./asset-source/sky.png";
import cloud2 from "./asset-source/cloud2.png";
import hyperNew from "./asset-source/startdesignwjet.png";
import chevron from "./asset-source/chevron.svg";
import Slider from "react-slick";

import sl1 from "./asset-source/sl1.svg";
import sl2 from "./asset-source/sl2.svg";
import sl3 from "./asset-source/sl3.svg";
import sl4 from "./asset-source/sl4.svg";
import sl5 from "./asset-source/sl5.svg";
import sl6 from "./asset-source/sl6.svg";
import sl7 from "./asset-source/sl7.svg";
import sl8 from "./asset-source/sl8.svg";

import { useState } from "react";
import { Header } from "./components/header-new/header";
import { Footer } from "./components/footer/footer";
import { Reviews } from "./components/reviews/reviews";

function App() {
	const [accrodeonActive, setAccorderonAcrive] = useState(0);

	document.title = "Wjet – О студии. Цифровые решения для бизнеса";
	document.getElementsByTagName("META")[2].content =
		"Студия цифрового дизайна Wjet. Создаем цифровые продукты, разрабатываем прототипы, проводим UX/UI аудит, консультации и исследования для вашего бизнеса.";

	document.getElementsByTagName("META")[3].content =
		"UX-исследования, Юзабилити-аудит, UX аудит, Дизайн интерфейсов, UX/UI проектирование, UI/UX дизайн, UI/UX для цифровых продуктов, Дизайн интерфейсов для приложений, Интерактивный прототип, Веб-дизайн, Адаптивный веб-дизайн, Создание MVP, Дизайн-система продукта";

	function handleAccordeonClick(num) {
		if (accrodeonActive === num) {
			setAccorderonAcrive(0);
		} else {
			setAccorderonAcrive(num);
		}
	}

	const settings = {
		dots: false,
		infinite: true,
		arrows: true,
		slidesToShow: 6,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 14000,
		cssEase: "linear",
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};

	return (
		<div className="App">
			<Header onLight />

			<section className="abouttop">
				<div className="aboutcontent">
					<div className="aboutgrid">
						<h1 className="h1 h1--main">О нас</h1>
						<div className="contentXL aboutaside">
							<div>
								<p>
									Создаём цифровые продукты:{" "}
									<nobr>проектируем интерфейсы,</nobr> разрабатываем мобильные
									и&nbsp;веб&nbsp;приложения, делаем дизайн-системы.
								</p>
								<p>
									Работаем как&nbsp;с&nbsp;крупными компаниями,
									так&nbsp;и&nbsp;с&nbsp;небольшими стартапами. Разбираемся
									в&nbsp;сложных технологиях, чтобы&nbsp;делать цифровые
									продукты понятными для&nbsp;обычных пользователей.
								</p>
							</div>

							<div className="aboutTitleLinks">
								<a href="#principles">Принципы</a>
								<a href="#values">Ценности</a>
								<a href="#partnership">Партнерам</a>
								<a href="#job">Вакансии</a>
								<a href="#reviews">Отзывы</a>
							</div>
						</div>
					</div>

					<div className="aboutBottomGrid">
						<div className="infoColumn">
							<div className="infoColumnTitle">3 года</div>
							<div>в среднем работаем с каждым клиентом</div>
						</div>

						<div className="infoColumn">
							<div className="infoColumnTitle">10+</div>
							<div>
								лет опыта в создании цифровых продуктов для разных отраслей
							</div>
						</div>

						<div className="infoColumn">
							<div className="infoColumnTitle">200+</div>
							<div>
								разработанных дизайнов продуктов для мобильных приложений,
								веб-сайтов и онлайн-платформ
							</div>
						</div>

						<div className="infoColumn">
							<div className="infoColumnTitle">от 2 недель</div>
							<div>
								срок разработки MVP для стартапов и тестирования гипотез на
								рынке
							</div>
						</div>

						<div className="infoColumn">
							<div className="infoColumnTitle">80%</div>
							<div>
								клиентов возвращаются для разработки новых функций или
								обновлений после успешной реализации первого проекта
							</div>
						</div>

						<div className="infoColumn">
							<div className="infoColumnTitle">98%</div>
							<div>проектов завершены в срок</div>
						</div>
					</div>
				</div>
			</section>

			<section id="values" className="valusSection">
				<div className="valuesGrid sectionContent">
					<div className="valuesTitleColumn">
						<h2 className="h2">Наши ценности</h2>
						<div className="valuesSubtitle">
							Хорошие вещи, в которые мы твердо верим
						</div>
					</div>

					<div className="valuesItem">
						<img src={plane} alt="" className="values__plane" />

						<h3 className="h3">Качество</h3>
						<div>
							Мы не терпим халтуру. В каждый проект стараемся вложить все свои
							ресурсы и творческий потенциал. Мы гордимся каждым своим проектом.
						</div>
					</div>

					<div className="valuesItem">
						<img src={cloud} alt="" className="values__cloud" />

						<h3 className="h3">Системный подход</h3>
						<div>
							Мы&nbsp;верим, что&nbsp;лучшие решения&nbsp;— это&nbsp;те, которые
							можно масштабировать и&nbsp;развивать, и&nbsp;стараемся
							к&nbsp;каждому проекту подходить именно&nbsp;так.
						</div>
					</div>

					<div className="valuesItem">
						<img src={sky} alt="" className="values__sky" />

						<h3 className="h3">Эффективность</h3>
						<div>
							Мы&nbsp;ценим время клиента, пользователя и&nbsp;своё, поэтому
							стараемся оптимизировать все&nbsp;процессы и&nbsp;избегать пустых
							разговоров и&nbsp;ненужной бюрократии.
						</div>
					</div>

					<div className="valuesItem">
						<img src={cloud2} alt="" className="values__plane" />

						<h3 className="h3">Открытость и&nbsp;партнёрство</h3>
						<div>
							Мы работаем с людьми, а не с роботами или бездушными цифрами,
							поэтому в основе всех наших процессов лежит прозрачность и
							дружеская коммуникация. Мы создаем проект не для заказчика, а
							вместе с ним.
						</div>
					</div>
				</div>
			</section>

			<section id="principles" className="principles__section">
				<div className="sectionContent principles__grid">
					<div className="principles__left">
						<h2 className="h2">
							Принципы дизайна, на&nbsp;которые мы опираемся
						</h2>
						<img src={hyperNew} alt="" className="hyperNew" />
					</div>

					<div className="principles__right">
						<div className="principle">
							<div className="principle__num">1</div>
							<div>
								<div className="principle__title">
									Смысл хорошего дизайна не в технической сложности и
									вау-эффектах, а в способности решать задачи пользователя и
									достигать целей проекта быстро и эффективно.
								</div>
								<div>
									<div
										className={
											accrodeonActive === 1
												? "principle__content principle__content--active"
												: "principle__content"
										}
									>
										Хороший интерфейс — это решение с высоким продуктовым КПД
										при минимальных затратах времени и усилий. Поэтому в
										цифровых продуктах, которые мы создаем, вместо сложных
										решений мы выбираем простоту и удобство, которые повышают
										конверсию и обеспечивают комфорт в ежедневном использовании.
									</div>
									<div
										className="principle__showmore"
										onClick={() => handleAccordeonClick(1)}
									>
										{accrodeonActive === 1 ? "Свернуть" : "Развернуть"}
										<img
											src={chevron}
											alt=""
											className={
												accrodeonActive === 1
													? "chvron chvron--active"
													: "chvron"
											}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="principle">
							<div className="principle__num">2</div>
							<div>
								<div className="principle__title">
									Стиль дизайна определяется потребностями пользователя, а не
									трендами или предпочтениями дизайнера.
								</div>
								<div>
									<div
										className={
											accrodeonActive === 2
												? "principle__content principle__content--active"
												: "principle__content"
										}
									>
										При работе с проектом мы первым делом определяем задачи и
										потребности целевой аудитории. Стиль будущего цифрового
										продукта должен быть уместным и соответствовать этим
										потребностям, как, например, спортивный костюм для
										соревнований или смокинг для официального приема.
										<br />
										Стиль также зависит от целей и функционала продукта.
										Например, для криптопроектов это может быть технологичный,
										контрастный дизайн с ярким визуалом, 3D-графикой или
										иллюстрациями, а для облачных платформ - системный, даже
										сухой, минималистичный подход, без визуальных излишеств,
										ориентированный на сетевых администраторов и программистов.
										<br />В нашей студии работают дизайнеры с разными
										компетенциями, что позволяет решать любые задачи. Как
										результат, наши продукты актуальны даже спустя годы, потому
										что в основе хорошо спроектированного цифрового продукта -
										потребности пользователей.
									</div>
									<div
										className="principle__showmore"
										onClick={() => handleAccordeonClick(2)}
									>
										{accrodeonActive === 2 ? "Свернуть" : "Развернуть"}
										<img
											src={chevron}
											alt=""
											className={
												accrodeonActive === 2
													? "chvron chvron--active"
													: "chvron"
											}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="principle">
							<div className="principle__num">3</div>
							<div>
								<div className="principle__title">
									Дизайн — это не только эстетика, но и инструмент, который
									решает задачи и приносит прибыль
								</div>
								<div>
									<div
										className={
											accrodeonActive === 3
												? "principle__content principle__content--active"
												: "principle__content"
										}
									>
										Создавать дизайн цифрового продукта — это продумывать
										сочетание функций, выстраивать информационную структуру,
										учитывать маркетинговые и бизнес-цели, а также проектировать
										удобное взаимодействие пользователя с продуктом. Каждый
										элемент дизайна важен и должен быть на своем месте, чтобы
										формировать прочную и функциональную структуру, которая не
										только привлекает внимание, но и решает задачи и приносит
										прибыль
									</div>
									<div
										className="principle__showmore"
										onClick={() => handleAccordeonClick(3)}
									>
										{accrodeonActive === 3 ? "Свернуть" : "Развернуть"}
										<img
											src={chevron}
											alt=""
											className={
												accrodeonActive === 3
													? "chvron chvron--active"
													: "chvron"
											}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Reviews />

			<section className="design" id="design">
				<div className="container">
					<div className="slider">
						<Slider className="slider__init" {...settings}>
							<div className="slider__item">
								<img src={sl1} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl2} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl3} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl4} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl5} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl6} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl7} alt="" />
							</div>

							<div className="slider__item">
								<img src={sl8} alt="" />
							</div>
						</Slider>
					</div>
				</div>

				<div className="container" id="contacts">
					<Footer backgroundColor="transparent" />
				</div>
			</section>
		</div>
	);
}

export default App;
